<template>
  <div id="multi-value-table">
    <b-table
      thead-class="hidden-header"
      striped
      hover
      responsive
      :items="items"
      :fields="fields"
      class="text-left"
    >
      <template
        slot="default"
        slot-scope="scope"
        class="mt-2"
      >
        <b-form-checkbox
          v-model="scope.item.default"
          :unchecked-value="false"
          :value="true"
          @change="selectedDefault(scope.index)"
        />
      </template>
      <template
        slot="no"
        slot-scope="scope"
        class="mt-2"
      >
        <p class="m-0 mt-1">
          {{ scope.index + 1 }}
        </p>
      </template>
      <template
        slot="name"
        slot-scope="scope"
        class="mt-2"
      >
        <p class="m-0 mt-1">
          {{ name(scope.item) }}
        </p>
      </template>
      <template
        slot="delete"
        slot-scope="scope"
      >
        <b-button
          class="del-btn"
          @click="delHandler(scope.index)"
        >
          ลบ
        </b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
    name: "MultiValueTable",
    props: {
        items: {
            type: Array
        },
        delHandler: {
            type: Function
        },
        type: {
            type: String
        }
    },
    data() {
        return {
            fields: ["default", "no", "name", "delete"]
        };
    },
    computed: {
      itemComputed: {
        get() {
          return this.items
        },
        set(val) {
          this.$emit('update:items', val)
        }
      }
    },
    methods: {
        name(item) {
            let name = "";
            switch (this.type) {
                case "address":
                    name = `${item.branch} ${item.subDistrict} ${item.district} ${item.province} ${item.postalCode}`;
                    break;
                case "phone":
                    name = item.value;
                    break;
                case "line":
                    name = item;
                    break;
                case "fax":
                    name = item.value;
                    break;
                case "email":
                    name = item.value;
                    break;
            }
            return name;
        },
        selectedDefault(index) {
          this.itemComputed[index].default = true

          // this.itemComputed.map((item, i) => {
          //   console.log(item, i)
          //   if (i !== index) {
          //     item.default = false
          //   }
          // })
        }
    }
};
</script>

<style scoped>
.del-btn {
    /*border-radius: 50%;*/
    background-color: rgba(169, 0, 13, 0.76);
    color: white;
    border: none;
}
</style>

<style>
.hidden-header {
    display: none;
}
</style>
